module.exports = __webpack_public_path__ + "static/media/112727-gics-mapbook_2018_v3_letter_digitalspreads.2cc80c63.pdf";